<eb-order-summary [cart]="cart$ | async"></eb-order-summary>
